export type { PluginBuild } from "esbuild";
export type { Options as HTMLMinifierOptions } from "html-minifier";
export type {
  optimize as optimizeSvg,
  OptimizedSvg,
  OptimizeOptions,
} from "svgo";
export type {
  parse as parseXML,
  tNode,
} from "txml/tXml.d.ts";
